export default "__VITE_ASSET__089906d6__"